import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { getApiKeyRole } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { ApiKeyRole } from '~/gen/proto/bff/v1/model_pb'

export function useApiKeyRole(id: string): ApiKeyRole {
  const { t } = useTranslation()
  const res = useSuspenseQuery(
    getApiKeyRole,
    { id },
    {
      select: (data) => data.role,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.apikey') }))
  }
  return res.data
}
